class FeaturedProduct {
  constructor(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.currentIndex = 0;
    
    // Elements
    this.images = container.querySelectorAll('.product-image');
    this.dots = container.querySelectorAll('.slider-dot');
    this.prevBtn = container.querySelector('.slider-prev');
    this.nextBtn = container.querySelector('.slider-next');
    this.form = container.querySelector('.product-form');
    this.gallery = container.querySelector('.product-gallery');
    this.variantInputs = container.querySelectorAll('.swatch-input__input');
    this.variantIdInput = container.querySelector('.product-variant-id');
    this.submitButton = container.querySelector('[data-add-to-cart]');
    
    this.totalImages = this.images.length;
    this.productData = window.featuredProductData?.[this.sectionId]?.product || null;
    
    this.init();
  }
  
  init() {
    this.setupSlider();
    this.setupVariantSelection();
    this.setupFormSubmission();
  }
  
  // ====== SLIDER FUNCTIONALITY ======
  setupSlider() {
    if (this.totalImages <= 1) return;
    
    this.dots.forEach(dot => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        this.goToSlide(parseInt(dot.dataset.mediaIndex));
      });
    });
    
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.previousSlide();
      });
    }
    
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.nextSlide();
      });
    }
    
    this.setupSwipeGestures();
  }
  
  setupSwipeGestures() {
    if (!this.gallery) return;
    
    let touchStartX = 0;
    
    this.gallery.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    this.gallery.addEventListener('touchend', (e) => {
      const touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      
      if (Math.abs(diff) > 50) {
        diff > 0 ? this.nextSlide() : this.previousSlide();
      }
    }, { passive: true });
  }
  
  goToSlide(index) {
    if (index < 0 || index >= this.totalImages) return;
    
    this.currentIndex = index;
    
    this.images.forEach((img, i) => {
      img.classList.toggle('active', i === index);
    });
    
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });
  }
  
  nextSlide() {
    this.goToSlide((this.currentIndex + 1) % this.totalImages);
  }
  
  previousSlide() {
    this.goToSlide((this.currentIndex - 1 + this.totalImages) % this.totalImages);
  }
  
  // ====== VARIANT SELECTION ======
  setupVariantSelection() {
    if (!this.variantInputs.length || !this.productData) return;
    
    this.variantInputs.forEach(input => {
      input.addEventListener('change', () => this.updateVariant());
    });
  }
  
  updateVariant() {
    if (!this.productData || !this.productData.variants) return;
    
    const selectedOptions = {};
    this.variantInputs.forEach(input => {
      if (input.checked) {
        const optionName = input.name.replace('options[', '').replace(']', '');
        selectedOptions[optionName] = input.value;
      }
    });
    
    const matchingVariant = this.productData.variants.find(variant => {
      return variant.options.every((option, index) => {
        const optionName = this.productData.options[index];
        return selectedOptions[optionName] === option;
      });
    });
    
    if (matchingVariant) {
      if (this.variantIdInput) {
        this.variantIdInput.value = matchingVariant.id;
      }
      
      if (this.submitButton) {
        if (matchingVariant.available) {
          this.submitButton.disabled = false;
          this.submitButton.querySelector('.btn__text').textContent = 
            this.submitButton.dataset.addToCartText || 'Add to Cart';
        } else {
          this.submitButton.disabled = true;
          this.submitButton.querySelector('.btn__text').textContent = 'Sold Out';
        }
      }
      
      this.updatePrice(matchingVariant);
    }
  }
  
  updatePrice(variant) {
    const priceElement = this.container.querySelector('.product-price');
    if (!priceElement || !variant) return;
    
    const formatMoney = (cents) => {
      return window.Shopify?.formatMoney 
        ? window.Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}')
        : `$${(cents / 100).toFixed(2)}`;
    };
    
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceElement.innerHTML = `
        <span class="price-compare">${formatMoney(variant.compare_at_price)}</span>
        <span class="price-sale">${formatMoney(variant.price)}</span>
        <span class="price-badge">Sale</span>
      `;
    } else {
      priceElement.innerHTML = `
        <span class="price-regular">${formatMoney(variant.price)}</span>
      `;
    }
  }
  
  // ====== FORM SUBMISSION ======
  setupFormSubmission() {
    if (!this.form) return;

    this.form.addEventListener('submit', (e) => {

      if (this.submitButton) {
        const btnText = this.submitButton.querySelector('.btn__text');
        if (btnText) {
          const originalText = btnText.textContent;
          btnText.textContent = 'Adding...';
          
          setTimeout(() => {
            btnText.textContent = originalText;
          }, 3000);
        }
      }
    });
  }
  
  async addToCart(variantId, formData) {
  }
  
  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const cartCountElements = document.querySelectorAll('[data-cart-count]');
      cartCountElements.forEach(el => {
        el.textContent = cart.item_count;
      });
      
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        cartDrawer.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);
          if (sectionElement) {
            sectionElement.innerHTML = this.getSectionInnerHTML(
              cart.sections[section.section],
              section.selector
            );
          }
        });
      }
      
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }
  
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

function initFeaturedProducts() {
  document.querySelectorAll('.featured-product-wrapper').forEach(section => {
    new FeaturedProduct(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFeaturedProducts);
} else {
  initFeaturedProducts();
}

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.featured-product-wrapper');
    if (section) {
      new FeaturedProduct(section);
    }
  });
  
  document.addEventListener('shopify:section:select', (event) => {
    const section = event.target.querySelector('.featured-product-wrapper');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
}